"use client";

import { useState } from "react";
import Link from "next/link";
import { useRouter, usePathname } from "next/navigation";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { trackEvent } from "@/lib/analytics";

export default function NotFoundActions() {
  const router = useRouter();
  const pathname = usePathname();
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  function handleSearch(e: React.FormEvent) {
    e.preventDefault();
    const q = query.trim();
    if (!q) return;
    setLoading(true);
    try {
      trackEvent("404_search", {
        query: q,
        path: pathname || (typeof window !== "undefined" ? window.location.pathname : ""),
      });
    } catch (e) {
      // ignore
    }

    // Navigate to home with query param - existing site search should read `?q=` if available
    router.push(`/?q=${encodeURIComponent(q)}`);
    setLoading(false);
  }

  const mailto = () => {
    const subject = `Broken link report: ${pathname || "/"}`;
    const body = `I tried to open this page (${typeof window !== "undefined" ? window.location.href : pathname}) and received a 404. Please investigate.`;
    return `mailto:admin@makeplans.tech?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <div className="mt-6 w-full max-w-md mx-auto sm:mx-0">
      {/* <form onSubmit={handleSearch} className="flex gap-2">
        <Input
          aria-label="Search the site"
          placeholder="Search guides, templates, or help..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <Button type="submit" className="shrink-0" disabled={loading}>
          Search
        </Button>
      </form> */}

      <div className="mt-4 flex flex-col sm:flex-row gap-3">
        <Link href="/" onClick={() => trackEvent("404_cta_clicked", { target: "home", path: pathname })} className="inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-medium text-primary-foreground gradient-bg">
          Go home
        </Link>
        <Link href="/templates" onClick={() => trackEvent("404_cta_clicked", { target: "templates", path: pathname })} className="inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-medium border border-border bg-card hover:bg-muted transition-colors">
          Browse templates
        </Link>
        <Link href={mailto()} onClick={() => trackEvent("404_report_clicked", { path: pathname })} className="inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-medium border border-border bg-card hover:bg-muted transition-colors">
          Report this page
        </Link>
      </div>

      <div className="mt-4 text-sm text-muted-foreground">
        <p>
          Prefer human help? <Link href="/contact" className="underline" onClick={() => trackEvent("404_cta_clicked", { target: "contact", path: pathname })}>Contact us</Link> and we’ll look into it.
        </p>
      </div>
    </div>
  );
}
